
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';


export const appRoutes: Routes = [
    //{ path: 'services', component: ServicesComponent },
    //{ path: 'cleaners', component: CleanersComponent },
    //{ path: 'datepicker', component: DatePickerComponent },
];


@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { useHash: true })
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class Routing {}



// WEBPACK FOOTER //
// ./src/app/app.routes.ts